export default __webpack_public_path__ + "static/media/gosro.e5b02226.png";